<template>
    <div class="record-release">
        <PageTitle
            icon="fa fa-exchange"
            main="Registro"
            sub="Lançamento de Registro"
        />
        <b-form>
            <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Operação:"
                        label-for="release-operation_id"
                    >
                        <b-form-select
                            id="release-operation_id"
                            @input=";[getAdvancedValue()]"
                            size="sm"
                            ref="inputFist"
                            :disabled="docRead"
                            :options="operations"
                            :state="operationState"
                            v-model="release.operation_id"
                        />
                        <b-form-invalid-feedback id="input-live-operation_id">
                            Falta Informar a Operação...
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col md="1" sm="2">
                    <b-form-group label="ID" label-for="entity-id">
                        <b-form-input
                            id="entity-id"
                            type="text"
                            title="ALT+L (Últimos Lançamento) | ALT+ENTER (PESQUISAR)"
                            v-model="release.entity_id"
                            @input="setEntity()"
                            @change="setEntity"
                            v-on:keyup.esc="docRead ? goback() : ''"
                            v-on:keyup.alt.enter="openModalEntity"
                            v-on:keyup.alt.76="loadLastReleases"
                            :readonly="docRead"
                            :state="entityState"
                            size="sm"
                            placeholder="Código..."
                        />
                        <b-form-invalid-feedback id="input-live-entity_id">
                            Falta Informar...
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-link
                    v-b-modal.modalEntity
                    v-if="!docRead"
                    class="fa fa-search mt-4"
                ></b-link>
                <b-col md="4" sm="8">
                    <b-form-group
                        label="Razão Social:"
                        label-for="entity-name_entity"
                    >
                        <b-form-input
                            id="entity-name_entity"
                            type="text"
                            v-model="entity.name_entity"
                            size="sm"
                            :readonly="true"
                            placeholder="Razão Social..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="2">
                    <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">
                        <b-form-input
                            id="entity-cnpj_cpf"
                            type="text"
                            v-model="entity.cnpj_cpf"
                            size="sm"
                            :readonly="true"
                            placeholder=""
                        />
                    </b-form-group>
                </b-col>
                <b-link
                    v-b-modal.modalRegisterEntity
                    v-if="!docRead"
                    class="fa fa-plus mt-4"
                >
                </b-link>
            </b-row>
            <b-row>
                <input id="release-id" type="hidden" v-model="release.id" />
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Lançado em:"
                        label-for="release-release_date"
                    >
                        <b-form-input
                            id="release-release_date"
                            type="date"
                            v-model="release.release_date"
                            :state="releaseDateState"
                            :readonly="docRead"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Tipo de Documento:"
                        label-for="release-type_document_id"
                    >
                        <b-form-select
                            id="release-type_document_id"
                            size="sm"
                            :state="typeDocumentState"
                            @input="loadSeries()"
                            :disabled="docRead"
                            :options="typedocuments"
                            v-model="release.type_document_id"
                        />
                        <b-form-invalid-feedback
                            id="input-live-type_document_id"
                        >
                            Falta Informar o Tipo do documento...
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col md="1" sm="12">
                    <b-form-group
                        label="Série:"
                        label-for="release-serie_type_document_id"
                    >
                        <b-form-select
                            id="release-serie_type_document_id"
                            size="sm"
                            :disabled="docRead"
                            :options="series"
                            v-model="release.serie_type_document_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Data de Emissão:"
                        label-for="release-issue_date"
                    >
                        <b-form-input
                            id="release-issue_date"
                            type="date"
                            title="ALT+H (DATA ATUAL)"
                            v-on:keyup.alt.72="setDateToday"
                            v-model="release.issue_date"
                            :state="issueDateState"
                            :readonly="docRead"
                            size="sm"
                        />
                        <b-form-invalid-feedback id="input-live-issue_date">
                            Falta Informar Data Emissão...
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Nº de Lançamento:"
                        label-for="release-release_number"
                    >
                        <b-form-input
                            id="release-release_number"
                            v-model="release.release_number"
                            :readonly="docRead"
                            :state="releaseNumberState"
                            type="number"
                            size="sm"
                        />
                        <b-form-invalid-feedback id="input-live-release_number">
                            Falta Informar o número do lançamento...
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Status:"
                        label-for="release-document_status_id"
                    >
                        <b-form-select
                            id="release-document_status_id"
                            size="sm"
                            :readonly="docRead"
                            disabled
                            :options="documentstatus"
                            v-model="release.document_status_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Condição:"
                        label-for="release-condition_payment_receipt_id"
                    >
                        <b-form-select
                            id="release-condition_payment_receipt_id"
                            size="sm"
                            :disabled="docRead"
                            :state="conditionPaymentReceiptState"
                            :options="conditionpaymentreceipts"
                            v-model="release.condition_payment_receipt_id"
                        />
                        <b-form-invalid-feedback
                            id="input-live-condition_payment_receipt_id"
                        >
                            Falta Informar a Condição de
                            Pagamento/Recebimento...
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Valor:"
                        label-for="release-release_value"
                    >
                        <b-form-input
                            id="release-release_value"
                            v-model="release.release_value"
                            type="number"
                            size="sm"
                            :state="releaseValueState"
                            :readonly="docRead"
                            v-on:keyup.alt.83="saveRelease"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                        <b-form-invalid-feedback id="input-live-release_value">
                            Falta Informar o Valor do Lançamento...
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Saldo Adiantamento:"
                        label-for="release-advanced_value"
                    >
                        <b-form-input
                            id="release-advanced_value"
                            v-model="release.advanced_value"
                            type="number"
                            size="sm"
                            :readonly="true"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="7" sm="12">
                    <b-form-group
                        label="Observação:"
                        label-for="release-comments"
                    >
                        <b-form-textarea
                            id="release-comments"
                            :rows="2"
                            :max-rows="6"
                            size="sm"
                            :readonly="docRead"
                            v-model="release.comments"
                            placeholder=""
                        />
                    </b-form-group>
                </b-col>
                <b-col md="5" sm="12">
                    <b-card
                        class="text-dark mb-2"
                        border-variant="Dark"
                        header="Informações do Registro"
                        header-bg-variant="dark"
                        header-text-variant="white"
                        style="max-width: 30rem;"
                        align="center"
                    >
                        <b-card-text>
                            <strong> Registrado em: </strong>
                            {{ this.formatDateTimeReg(this.release.register) }}
                            | <strong> Alterado em: </strong>
                            {{
                                this.release.update_date
                                    ? this.formatDateTimeReg(
                                          this.release.update_date
                                      )
                                    : ''
                            }}
                        </b-card-text>
                        <b-card-text>
                            <strong> Valor Total: </strong>
                            {{ this.release.release_value }} |
                            <strong> Parcela(s): </strong>
                            {{
                                this.formatValue(
                                    this.splotSum[this.splotSum.length - 1]
                                )
                            }}
                            | <strong> Rateio(s): </strong>
                            {{
                                this.formatValue(
                                    this.apportionSum[
                                        this.apportionSum.length - 1
                                    ]
                                )
                            }}
                            | <strong> Retenções: </strong>
                            {{
                                this.formatValue(
                                    this.retentionSum[
                                        this.retentionSum.length - 1
                                    ]
                                )
                            }}
                        </b-card-text>
                    </b-card>
                </b-col>
            </b-row>
        </b-form>
        <b-row>
            <b-col xs="12">
                <b-button
                    size="lq"
                    variant="dark"
                    title="Salvar registro"
                    v-show="!docRead"
                    class="fa fa-save"
                    @click="saveRelease"
                >
                </b-button>
                <b-button
                    size="lq"
                    variant="dark"
                    title="Retornar tela de consulta"
                    class="ml-2 fa fa-reply"
                    @click="goback"
                >
                </b-button>
                <b-button
                    size="lq"
                    variant="dark"
                    title="Usar preenchimento automático"
                    class="ml-2 fa fa-exchange"
                    v-show="!this.release.checkvalueplot"
                    v-if="
                        this.release.id > 0 &&
                            this.release.document_status_id === 1
                    "
                    @click="automaticRelease()"
                >
                </b-button>
                <b-button
                    size="lq"
                    variant="dark"
                    title="Validar registro"
                    class="ml-2  fa fa-check"
                    v-show="!this.release.checkvalueplot"
                    v-if="
                        this.release.id > 0 &&
                            this.release.document_status_id === 1
                    "
                    @click="validatedValueSplot()"
                >
                </b-button>
                <b-button
                    size="lq"
                    variant="dark"
                    class="ml-2"
                    v-show="this.release.checkvalueplot"
                    v-if="this.release.document_status_id === 1"
                    @click=";[confirmRelease()]"
                    >Confirmar</b-button
                >

            </b-col>
        </b-row>
        <hr />
        <b-card
            bg-variant="light"
            text-variant="dark"
            no-body
            v-show="this.release.id > 0 ? true : false"
        >
            <b-tabs pills card small>
                <b-tab title="Parcela" active>
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-button
                                title="Adicionar Parcela(Manual)"
                                size="sm"
                                @click="setNewSplot"
                                v-b-modal.modalPlots
                                v-show="
                                    this.release.document_status_id === 1 &&
                                    this.release.id > 0
                                        ? true
                                        : false
                                "
                                variant="dark"
                                class="mr-2 mb-2 fa fa-plus"
                            >
                            </b-button>
                            <b-button
                                title="Parcela(s) Definição"
                                @click="addSpot"
                                v-b-modal.modalSplotConditionPayment
                                size="sm"
                                v-show="
                                    this.release.document_status_id === 1 &&
                                    this.release.id > 0
                                        ? true
                                        : false
                                "
                                variant="dark"
                                class="mr-2 mb-2 fa fa-snowflake-o"
                            >
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" sm="12">
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    sticky-header
                                    head-variant="light"
                                    hover
                                    key="slide"
                                    :items="releasesplots"
                                    :fields="fieldsPlot"
                                >
                                    <template v-slot:cell(actions)="data">
                                        <b-button
                                            title="Bloquear Pagamento/Recebimento"
                                            v-show="
                                                data.item.blocked == 0 &&
                                                data.item.closed == 0
                                                    ? true
                                                    : false
                                            "
                                            v-b-modal.modalBlocked
                                            size="sm"
                                            variant="light"
                                            @click="loadReleasesPlot(data.item)"
                                            class="mr-2 mt-2"
                                        >
                                            <i class="fa fa-unlock-alt"></i>
                                        </b-button>
                                        <b-button
                                            title="Liberar Pagamento/Recebimento"
                                            v-show="
                                                data.item.blocked == 1 &&
                                                data.item.closed == 0
                                                    ? true
                                                    : false
                                            "
                                            v-b-modal.modalUnBlocked
                                            size="sm"
                                            variant="light"
                                            @click="loadReleasesPlot(data.item)"
                                            class="mr-2 mt-2"
                                        >
                                            <i class="fa fa-unlock"></i>
                                        </b-button>
                                        <b-button
                                            title="Editar registro"
                                            v-show="
                                                !docRead &&
                                                data.item.closed == 0
                                                    ? true
                                                    : false
                                            "
                                            v-b-modal.modalPlots
                                            size="sm"
                                            variant="light"
                                            @click="loadReleasesPlot(data.item)"
                                            class="mr-2 mt-2"
                                        >
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            v-show="
                                                !docRead &&
                                                data.item.closed == 0
                                                    ? true
                                                    : false
                                            "
                                            variant="light"
                                            @click="modePlot = 'remove'"
                                            class="mr-2 mt-2"
                                            v-if="modePlot === 'insert'"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                ;[
                                                    removePlot(data.item),
                                                    (modePlot = 'insert')
                                                ]
                                            "
                                            class="mr-2 mt-2"
                                            v-if="modePlot === 'remove'"
                                        >
                                            <i class="fa fa-check"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="modePlot = 'insert'"
                                            class="mr-2 mt-2"
                                            v-if="modePlot === 'remove'"
                                        >
                                            <i class="fa fa-times"></i>
                                        </b-button>
                                        <span
                                            class="mr-2 mt-2"
                                            v-if="modePlot === 'remove'"
                                        >
                                            Deseja Excluir o registro?
                                        </span>
                                    </template>
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Classificação">
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-button
                                size="sm"
                                v-b-modal.modalApportionment
                                @click="setNewApportionment"
                                v-show="
                                    this.release.document_status_id === 1 &&
                                    this.release.id > 0
                                        ? true
                                        : false
                                "
                                variant="dark"
                                class="mr-2 mb-2 fa fa-plus"
                            ></b-button>
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    sticky-header
                                    head-variant="light"
                                    hover
                                    key="slide"
                                    :items="releasesapportionments"
                                    :fields="fieldsApportionment"
                                >
                                    <template v-slot:cell(actions)="data">
                                        <b-button
                                            title="Editar registro"
                                            v-b-modal.modalApportionment
                                            size="sm"
                                            variant="light"
                                            @click="
                                                loadreleasesApportionment(
                                                    data.item
                                                )
                                            "
                                            class="mr-2 mt-2"
                                        >
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                modeApportionment = 'remove'
                                            "
                                            class="mr-2 mt-2"
                                            v-if="
                                                modeApportionment === 'insert'
                                            "
                                        >
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                ;[
                                                    removeApportionment(
                                                        data.item
                                                    ),
                                                    (modeApportionment =
                                                        'insert')
                                                ]
                                            "
                                            class="mr-2 mt-2"
                                            v-if="
                                                modeApportionment === 'remove'
                                            "
                                        >
                                            <i class="fa fa-check"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                modeApportionment = 'insert'
                                            "
                                            class="mr-2 mt-2"
                                            v-if="
                                                modeApportionment === 'remove'
                                            "
                                        >
                                            <i class="fa fa-times"></i>
                                        </b-button>
                                        <span
                                            class="mr-2 mt-2"
                                            v-if="
                                                modeApportionment === 'remove'
                                            "
                                        >
                                            Deseja Excluir o registro?
                                        </span>
                                    </template>
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Retenção">
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-button
                                size="sm"
                                v-b-modal.modalRetention
                                @click="setNewRetention"
                                v-show="!docRead ? true : false"
                                variant="dark"
                                class="mr-2 mb-2"
                            >
                                <i class="fa fa-plus"></i
                            ></b-button>
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    sticky-header
                                    head-variant="light"
                                    hover
                                    key="slide"
                                    :items="releasesretentions"
                                    :fields="fieldsRetention"
                                >
                                    <template v-slot:cell(actions)="data">
                                        <b-button
                                            title="Editar registro"
                                            v-show="!docRead ? true : false"
                                            v-b-modal.modalRetention
                                            size="sm"
                                            variant="light"
                                            @click="
                                                loadreleasesRetention(data.item)
                                            "
                                            class="mr-2 mt-2"
                                        >
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            v-show="!docRead ? true : false"
                                            @click="modeRetention = 'remove'"
                                            class="mr-2 mt-2"
                                            v-if="modeRetention === 'insert'"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                ;[
                                                    removeRetention(data.item),
                                                    (modeRetention = 'insert')
                                                ]
                                            "
                                            class="mr-2 mt-2"
                                            v-if="modeRetention === 'remove'"
                                        >
                                            <i class="fa fa-check"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="modeRetention = 'insert'"
                                            class="mr-2 mt-2"
                                            v-if="modeRetention === 'remove'"
                                        >
                                            <i class="fa fa-times"></i>
                                        </b-button>
                                        <span
                                            class="mr-2 mt-2"
                                            v-if="modeRetention === 'remove'"
                                        >
                                            Deseja Excluir o registro?
                                        </span>
                                    </template>
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Imposto">
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-button
                                size="sm"
                                v-b-modal.modalTax
                                @click="setNewTax"
                                v-show="!docRead ? true : false"
                                variant="dark"
                                class="mr-2 mb-2"
                            >
                                <i class="fa fa-plus"></i
                            ></b-button>
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    sticky-header
                                    head-variant="light"
                                    hover
                                    key="slide"
                                    striped
                                    :items="releasestaxs"
                                    :fields="fieldsTax"
                                >
                                    <template v-slot:cell(actions)="data">
                                        <b-button
                                            title="Editar registro"
                                            v-b-modal.modalTax
                                            size="sm"
                                            variant="light"
                                            @click="loadreleasesTax(data.item)"
                                            class="mr-2 mt-2 fa fa-pencil"
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            title="remover registro"
                                            @click="modeTax = 'remove'"
                                            class="mr-2 mt-2 fa fa-trash"
                                            v-if="modeTax === 'insert'"
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                ;[
                                                    removeTax(data.item),
                                                    (modeTax = 'insert')
                                                ]
                                            "
                                            class="mr-2 mt-2"
                                            v-if="modeTax === 'remove'"
                                        >
                                            <i class="fa fa-check"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="modeTax = 'insert'"
                                            class="mr-2 mt-2"
                                            v-if="modeTax === 'remove'"
                                        >
                                            <i class="fa fa-times"></i>
                                        </b-button>
                                        <span
                                            class="mr-2 mt-2"
                                            v-if="modeTax === 'remove'"
                                        >
                                            Deseja Excluir o registro?
                                        </span>
                                    </template>
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Item">
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-button
                                title="Adicionar Item"
                                size="sm"
                                v-b-modal.modalReleaseItem
                                v-show="
                                    this.release.document_status_id === 1 &&
                                    this.release.id > 0
                                        ? true
                                        : false
                                "
                                variant="dark"
                                class="mr-2 mb-2 fa fa-plus"
                            ></b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" sm="12">
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    hover
                                    key="slide"
                                    head-variant="light"
                                    :items="releasesitems"
                                    :fields="fieldsReleaseItem"
                                >
                                    <template slot="actions" slot-scope="data">
                                        <b-button
                                            title="Editar registro"
                                            v-show="!docRead"
                                            v-b-modal.modalReleaseItem
                                            size="sm"
                                            variant="warning"
                                            @click="loadReleaseItem(data.item)"
                                            class="mr-2 mt-2"
                                        >
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            v-show="!docRead"
                                            variant="light"
                                            @click="modeItem = 'remove'"
                                            class="mr-2 mt-2"
                                            v-if="modeItem === 'insert'"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                ;[
                                                    removeItem(data.item),
                                                    (modeItem = 'insert')
                                                ]
                                            "
                                            class="mr-2 mt-2"
                                            v-if="modeItem === 'remove'"
                                        >
                                            <i class="fa fa-check"></i>
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="modeItem = 'insert'"
                                            class="mr-2 mt-2"
                                            v-if="modeItem === 'remove'"
                                        >
                                            <i class="fa fa-times"></i>
                                        </b-button>
                                        <span
                                            class="mr-2 mt-2"
                                            v-if="modeItem === 'remove'"
                                        >
                                            Deseja Excluir o registro?
                                        </span>
                                    </template>
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </b-card>
        <b-modal
            id="modalPlots"
            ref="modal"
            title-tag="h6"
            title="Parcelas"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="savePlot"
        >
            <b-form>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data de Vencto:"
                            label-for="releasesplot-due_date"
                        >
                            <b-form-input
                                id="releasesplot-due_date"
                                type="date"
                                v-model="releasesplot.due_date"
                                @input="setDueDate()"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data Programada:"
                            label-for="releasesplot-scheduled_date"
                        >
                            <b-form-input
                                id="releasesplot-scheduled_date"
                                type="date"
                                v-model="releasesplot.scheduled_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Parcela:"
                            label-for="releasesplot-portion_value"
                        >
                            <b-form-input
                                id="releasesplot-portion_value"
                                v-model="releasesplot.portion_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Multa:"
                            label-for="releasesplot-fine_value"
                        >
                            <b-form-input
                                id="releasesplot-fine_value"
                                v-model="releasesplot.fine_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Juros:"
                            label-for="releasesplot-interest_rate_value"
                        >
                            <b-form-input
                                id="releasesplot-interest_rate_value"
                                v-model="releasesplot.interest_rate_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Desconto:"
                            label-for="releasesplot-discount_value"
                        >
                            <b-form-input
                                id="releasesplot-discount_value"
                                v-model="releasesplot.discount_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Final:"
                            label-for="releasesplot-final_value"
                        >
                            <b-form-input
                                id="releasesplot-final_value"
                                v-model="releasesplot.final_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                :readonly="true"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="Forma de Pagamento/Recebimento:"
                            label-for="releasesplot-settlement_form_id"
                        >
                            <b-form-select
                                id="releasesplot-settlement_form_id"
                                size="sm"
                                :options="settlementforms"
                                v-model="releasesplot.settlement_form_id"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>

        <b-modal
            id="modalRetention"
            ref="modal"
            title-tag="h6"
            title="Retenção"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveRetention"
        >
            <b-form>
                <b-row>
                    <b-col md="8" sm="12">
                        <b-form-group
                            label="Retenção:"
                            label-for="releasesretention-retention_id"
                        >
                            <b-form-select
                                id="releasesretention-retention_id"
                                size="sm"
                                :options="retentions"
                                v-model="releasesretention.retention_id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="%:"
                            label-for="releasesretention-percent"
                        >
                            <b-form-input
                                id="releasesretention-percent"
                                v-model="releasesretention.percent"
                                @input="retentionValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data base:"
                            label-for="releasesretention-base_date"
                        >
                            <b-form-input
                                id="releasesretention-base_date"
                                type="date"
                                v-model="releasesretention.base_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data Vencto:"
                            label-for="releasesretention-due_date"
                        >
                            <b-form-input
                                id="releasesretention-due_date"
                                type="date"
                                v-model="releasesretention.due_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Base:"
                            label-for="releasesretention-base_retention_value"
                        >
                            <b-form-input
                                id="releasesretention-base_retention_value"
                                v-model="releasesretention.base_retention_value"
                                @input="retentionValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Retido:"
                            label-for="releasesretention-retention_value"
                        >
                            <b-form-input
                                id="releasesretention-retention_value"
                                v-model="releasesretention.retention_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>

        <b-modal
            id="modalTax"
            ref="modal"
            title-tag="h6"
            title="Imposto"
            size="lq"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveTax"
        >
            <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Imposto:"
                            label-for="releasestax-tax_id"
                        >
                            <b-form-select
                                id="releasestax-tax_id"
                                size="sm"
                                :options="taxs"
                                v-model="releasestax.tax_id"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data base:"
                            label-for="releasestax-base_date"
                        >
                            <b-form-input
                                id="releasestax-base_date"
                                type="date"
                                v-model="releasestax.base_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Base:"
                            label-for="releasestax-base_tax_value"
                        >
                            <b-form-input
                                id="releasestax-base_tax_value"
                                v-model="releasestax.base_tax_value"
                                @input="taxValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="%:"
                            label-for="releasestax-percent"
                        >
                            <b-form-input
                                id="releasestax-percent"
                                v-model="releasestax.percent"
                                @input="taxValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Vr.Imposto:"
                            label-for="releasestax-tax_value"
                        >
                            <b-form-input
                                id="releasestax-tax_value"
                                v-model="releasestax.tax_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Vr.Isento:"
                            label-for="releasestax-tax_free_value"
                        >
                            <b-form-input
                                id="releasestax-tax_free_value"
                                v-model="releasestax.tax_free_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Vr.Outros:"
                            label-for="releasestax-tax_others_value"
                        >
                            <b-form-input
                                id="releasestax-tax_others_value"
                                v-model="releasestax.tax_others_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setSearchEntity"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity.name_entity = $event"
                @setEntityCnpjCpf="entity.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalUnBlocked"
            ref="modal"
            title-tag="h6"
            title="Liberar Pagamento/Recebimento"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="unblocked"
        >
            <p class="my-4">
                Este Procedimento irá liberar a parcela para
                pagamento/recebimento no valor de:
                <b-badge>{{ releasesplot.final_value }}</b-badge>
            </p>
        </b-modal>
        <b-modal
            id="modalBlocked"
            ref="modal"
            title-tag="h6"
            title="Bloquear Pagamento/Recebimento"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="blocked"
        >
            <p class="my-4">
                Este Procedimento irá bloquear a parcela para
                pagamento/recebimento no valor de:
                <b-badge>{{ releasesplot.final_value }}</b-badge>
            </p>
        </b-modal>
        <b-modal
            id="modalSplotConditionPayment"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Informe o meio de Pagamento/Recebimento"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="insertReleaseSplotConfditionPayment"
        >
            <b-row>
                <b-col md="12" sm="12">
                    <b-form-group
                        label="Forma de Pagamento/Recebimento:"
                        label-for="release-settlement_form_id"
                    >
                        <b-form-select
                            id="release-settlement_form_id"
                            @input="
                                ;[
                                    loadSettlementOption(),
                                    loadAccountCreditCards()
                                ]
                            "
                            @change="loadAccountCreditCards"
                            size="sm"
                            :options="settlementforms"
                            v-model="releasesplot.settlement_form_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-show="settlementform.credit_card == 1 ? true : false">
                <b-col md="12" sm="12">
                    <b-form-group
                        label="Cartão:"
                        label-for="releasesplot-account_credit_card_id"
                    >
                        <b-form-select
                            id="releasesplot-account_credit_card_id"
                            @input="loadAccountCreditCardsRates()"
                            @change="loadAccountCreditCardsRates"
                            size="sm"
                            :options="accountcreditcards"
                            v-model="releasesplot.account_credit_card_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-show="settlementform.credit_card == 1 ? true : false">
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Modalidade:"
                        label-for="releasesplot-account_credit_card_rate_id"
                    >
                        <b-form-select
                            id="releasesplot-account_credit_card_rate_id"
                            @input="loadAccountCreditCardsRateConditions()"
                            @change="loadAccountCreditCardsRateConditions"
                            size="sm"
                            :options="accountcreditcardsrates"
                            v-model="releasesplot.account_credit_card_rate_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Prazo:"
                        label-for="releasesplot-account_credit_card_rate_condition_id"
                    >
                        <b-form-select
                            id="releasesplot-account_credit_card_rate_condition_id"
                            size="sm"
                            :options="accountcreditcardsratesconditionreceipts"
                            v-model="
                                releasesplot.account_credit_card_rate_condition_id
                            "
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal
            id="modalApportionment"
            ref="modal"
            size="lg"
            title-tag="h6"
            title="Rateio Custo/Receita"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveApportionment"
        >
            <b-form>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Tipo:"
                            label-for="apportionment-apportionment_type_cost_id"
                        >
                            <b-form-select
                                id="apportionment-apportionment_type_cost_id"
                                size="sm"
                                :options="typecosts"
                                v-model="
                                    releasesapportionment.apportionment_type_cost_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="1º Nível:"
                            label-for="apportionment-apportionment_operation_level_one_id"
                        >
                            <b-form-select
                                id="apportionment-apportionment_operation_level_one_id"
                                @input="loadOperationsLevelTwos"
                                size="sm"
                                :options="operationslevelones"
                                v-model="
                                    releasesapportionment.apportionment_operation_level_one_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="5" sm="12">
                        <b-form-group
                            label="2º Nível:"
                            label-for="apportionment-apportionment_operation_level_two_id"
                        >
                            <b-form-select
                                id="apportionment-apportionment_operation_level_two_id"
                                size="sm"
                                :options="operationsleveltwos"
                                v-model="
                                    releasesapportionment.apportionment_operation_level_two_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="8" sm="12">
                        <b-form-group
                            label="Centro de Resultado:"
                            label-for="releasesapportionment-apportionment_cost_center_id"
                        >
                            <b-form-select
                                id="releasesapportionment-apportionment_cost_center_id"
                                size="sm"
                                :options="costcenters"
                                v-model="
                                    releasesapportionment.apportionment_cost_center_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="%:"
                            label-for="releasesapportionment-apportionment_percent"
                        >
                            <b-form-input
                                id="releasesapportionment-apportionment_percent"
                                v-model="
                                    releasesapportionment.apportionment_percent
                                "
                                type="number"
                                size="sm"
                                @input="apportionmentValue"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Valor:"
                            label-for="releasesapportionment-apportionment_value"
                        >
                            <b-form-input
                                id="releasesapportionment-apportionment_value"
                                v-model="
                                    releasesapportionment.apportionment_value
                                "
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
        <b-modal
            id="modalLastRelease"
            ref="modal"
            hide-footer
            size="lg"
            title-tag="h6"
            title="Registro dos Ultimos lançamentos"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-table
                    class="table-responsive"
                    head-variant="dark"
                    hover
                    striped
                    :items="last_releases_entitys"
                    :fields="fieldsLastRelease"
                >
                    <template slot="actions" slot-scope="data">
                        <b-button
                            title="Copiar o registro"
                            size="sm"
                            variant="light"
                            v-b-modal.modalNewRelease
                            @click=";[setLastRelease(data.item)]"
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-check-square-o"></i>
                        </b-button>
                        <b-button
                            title="Editar registro"
                            size="sm"
                            variant="warning"
                            @click="
                                ;[hideModal(), actionEditRelease(data.item)]
                            "
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-pencil"></i>
                        </b-button>
                    </template>
                </b-table>
            </b-form>
        </b-modal>

        <b-modal
            id="modalNewRelease"
            ref="modal"
            title-tag="h6"
            title="Gerar novo Lançamento "
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveNewRelease"
        >
            <b-form>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data de Emissão:"
                            label-for="newrelease-issue_date"
                        >
                            <b-form-input
                                id="newrelease-issue_date"
                                type="date"
                                v-model="newrelease.issue_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Nº de Lançamento:"
                            label-for="newrelease-release_number"
                        >
                            <b-form-input
                                id="newrelease-release_number"
                                v-model="newrelease.release_number"
                                type="number"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor:"
                            label-for="newrelease-release_value"
                        >
                            <b-form-input
                                id="newrelease-release_value"
                                v-model="newrelease.release_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalReleaseItem"
            ref="modal"
            size="lg"
            title-tag="h6"
            @shown="focusModalEntryItem"
            title="Item"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveReleaseItem"
        >
            <b-form>
                <b-row>
                    <b-col md="2" sm="2">
                        <b-form-group
                            label="ID:"
                            label-for="releasesitem-item_id"
                        >
                            <b-form-input
                                id="releasesitem-item_id"
                                type="text"
                                ref="focusEntryItem"
                                v-model="releasesitem.item_id"
                                @input=";[setItem()]"
                                v-on:keyup.enter="
                                    releasesitem && releasesitem.item_id > 0
                                        ? focusModalEntryItemQuantity()
                                        : openModalItem()
                                "
                                size="sm"
                                placeholder="Código..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-link
                        class="fa fa-search mt-4"
                        v-b-modal.modalItem
                        @click=";[loadItems(), (showItem = true)]"
                    >
                    </b-link>
                    <b-col md="8" sm="8">
                        <b-form-group
                            label="Nome:"
                            label-for="item-complements_name"
                        >
                            <b-form-input
                                id="item-complements_name"
                                type="text"
                                v-model="item.complements_name"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="1" sm="2">
                        <b-form-group label="Unid:" abel-for="item-initials">
                            <b-form-input
                                id="item-initials"
                                type="text"
                                v-model="item.initials"
                                size="sm"
                                :readonly="true"
                                placeholder="Unid."
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Qtde:"
                            label-for="releasesitem-quantity"
                        >
                            <b-form-input
                                id="releasesitem-quantity"
                                v-model="releasesitem.quantity"
                                ref="focusEntryItemQuantity"
                                @input="ItemValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Valor Unitário:"
                            label-for="releasesitem-value_unit"
                        >
                            <b-form-input
                                id="releasesitem-value_unit"
                                v-model="releasesitem.value_unit"
                                @input=";[ItemValue(), ItemUnitFinalValue()]"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Valor Desconto:"
                            label-for="releasesitem-value_discount"
                        >
                            <b-form-input
                                id="releasesitem-value_discount"
                                v-model="releasesitem.entry_value_discount"
                                @input=";[ItemValue(), ItemUnitFinalValue()]"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Valor Total:"
                            label-for="releasesitem-value_total"
                        >
                            <b-form-input
                                id="releasesitem-value_total"
                                v-model="releasesitem.value_total"
                                type="number"
                                size="sm"
                                :readonly="true"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Observação:"
                            label-for="releasesitem-comments"
                        >
                            <b-form-textarea
                                id="releasesitem-comments"
                                :rows="2"
                                :max-rows="6"
                                size="sm"
                                v-model="releasesitem.comments"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalItem"
            ref="modal"
            hide-footer
            title-tag="h6"
            @shown="focusModalItem"
            size="lg"
            title="Consulta de Item"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-row>
                    <b-col md="8" sm="8">
                        <b-form-group
                            label="Descrição:"
                            label-for="item-complements_name"
                        >
                            <b-form-input
                                id="item-complements_name"
                                type="text"
                                v-model="item.complements_name"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="2">
                        <b-form-group label="Und:" label-for="entity-initials">
                            <b-form-input
                                id="entity-initials"
                                type="text"
                                v-model="item.initials"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <div class="col-sm-8">
                        <div class="form-group">
                            <label class="control-label">
                                <i class="fa fa-search"></i>
                                Pesquisar
                            </label>
                            <b-button
                                size="sm"
                                class=" ml-2 mb-2 fa fa-search"
                                @click=";[loadItems(), (showItem = !showItem)]"
                                variant="secondary"
                            ></b-button>
                            <input
                                type="text"
                                icon="search"
                                v-model="searchItem"
                                ref="focusItem"
                                v-on:keyup.enter="
                                    ;[loadItems(), (showItem = true)]
                                "
                                placeholder="Informe a descrição"
                                class="form-control"
                            />
                            <b-form-select
                                id="item-group_item_id"
                                class="mt-2"
                                size="sm"
                                :options="groupitems"
                                @input="loadItems"
                                v-model="group_item_id"
                            />
                        </div>
                    </div>
                </b-row>
                <b-table
                    class="table-responsive"
                    hover
                    striped
                    v-show="showItem"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :items="filteredListItems"
                    :fields="fieldsItems"
                >
                    <template slot="actions" slot-scope="data">
                        <b-button
                            title="Selecionar o registro"
                            size="sm"
                            variant="secondary"
                            @click="
                                ;[
                                    setItemSearch(data.item),
                                    (showItem = !showItem),
                                    hideModal()
                                ]
                            "
                            class="mr-2 mt-2 fa fa-check-square-o"
                        >
                        </b-button>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rowsItems"
                    :per-page="perPage"
                    aria-controls="my-table"
                ></b-pagination>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
var moment = require('moment-timezone')

export default {
    name: 'Recordrelease',
    components: { PageTitle, EntityModal, EntitySearchModal },
    data: function() {
        return {
            mode: 'save',
            modeRetention: 'insert',
            modeApportionment: 'insert',
            modeTax: 'insert',
            modeItem: 'insert',
            modePlot: 'insert',
            searchItem: '',
            showItem: false,
            entity_id: null,
            docRead: false,
            group_item_id: null,
            splotsettlement: false,
            documentstatus: [],
            groupitems: [],
            accountcreditcards: [],
            accountcreditcardsrates: [],
            accountcreditcardsratesconditionreceipts: [],
            release: {},
            oldrelease: {},
            newrelease: {},
            last_release_entity: {},
            last_releases_entitys: [],
            releasesretention: {},
            releasesretentions: [],
            releasesapportionment: {},
            releasesapportionments: [],
            releasestax: {},
            releasestaxs: [],
            releasesplot: {},
            releasesplots: [],
            releasesitem: {},
            releasesitems: [],
            retentions: [],
            taxs: [],
            entity: {},
            typedocuments: [],
            costcenters: [],
            operations: [],
            operationsleveltwos: [],
            operationslevelones: [],
            conditionpaymentreceipts: [],
            typecosts: [],
            settlementforms: [],
            entitysettlements: [],
            items: [],
            series: [],
            item: {},
            settlementform: {},
            documentsettlement: {},
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            perPage: 5,
            currentPage: 1,
            fieldsRetention: [
                { key: 'name_retention', label: 'Retenção', sortable: false },
                {
                    key: 'base_date',
                    label: 'Data Base',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'due_date',
                    label: 'Data Vencto',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'base_retention_value',
                    label: 'Valor Base',
                    sortable: false
                },
                { key: 'percent', label: '%', sortable: false },
                {
                    key: 'retention_value',
                    label: 'Valor Retido',
                    sortable: false
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsTax: [
                { key: 'name_tax', label: 'Imposto', sortable: false },
                { key: 'base_tax_value', label: 'Base', sortable: false },
                { key: 'percent', label: '%', sortable: false },
                { key: 'tax_value', label: 'Vr.Imposto', sortable: false },
                { key: 'tax_free_value', label: 'Vr.Isento', sortable: false },
                {
                    key: 'tax_others_value',
                    label: 'Vr.Outros',
                    sortable: false
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsApportionment: [
                {
                    key: 'name_type_cost',
                    label: 'Tipo',
                    sortable: false
                },
                {
                    key: 'name_cost_center',
                    label: 'Centro de Resultado',
                    sortable: false
                },
                {
                    key: 'name_operation_level_two',
                    label: 'Operação',
                    sortable: false
                },
                { key: 'apportionment_percent', label: '%', sortable: false },
                { key: 'apportionment_value', label: 'Valor', sortable: false },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsItemStock: [
                { key: 'item_id', label: 'Item', sortable: false },
                {
                    key: 'complements_name',
                    label: 'Descrição',
                    sortable: false
                },
                { key: 'location', label: 'Complemento', sortable: false },
                { key: 'initials', label: 'Und.', sortable: false },
                {
                    key: 'stock_quantity',
                    label: 'Qtde. Estoque',
                    sortable: false
                },
                {
                    key: 'price_unit_stock',
                    label: 'Vr. Custo',
                    sortable: false
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsItems: [
                { key: 'id', label: 'Item', sortable: false },
                {
                    key: 'complements_name',
                    label: 'Descrição',
                    sortable: false,
                    variant: 'secondary'
                },
                { key: 'initials', label: 'Und.', sortable: false },
                {
                    key: 'name_group_item',
                    label: 'Grupo de Item',
                    sortable: false
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsPlot: [
                {
                    key: 'due_date',
                    label: 'Vencto',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'scheduled_date',
                    label: 'Programação',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'portion_value',
                    label: 'Valor Parcela',
                    sortable: false
                },
                { key: 'fine_value', label: 'Valor Multa', sortable: false },
                {
                    key: 'interest_rate_value',
                    label: 'Valor Juros',
                    sortable: false
                },
                {
                    key: 'discount_value',
                    label: 'Valor Desconto',
                    sortable: false
                },
                { key: 'final_value', label: 'Valor Final', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'closed',
                    label: 'Status',
                    sortable: false,
                    formatter: value => (value ? 'Pago' : 'Em Aberto')
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsLastRelease: [
                { key: 'name_operation', label: 'Tipo.', sortable: false },
                {
                    key: 'issue_date',
                    label: 'Data Emissão',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'name_reduced', label: 'Tipo Doc.', sortable: false },
                { key: 'release_number', label: 'Nº.', sortable: false },
                { key: 'release_value', label: 'Valor', sortable: false },
                {
                    key: 'name_operation_level_two',
                    label: 'Sub.Operação',
                    sortable: false
                },
                {
                    key: 'name_document_status',
                    label: 'Status',
                    sortable: false,
                    variant: 'secondary'
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsReleaseItem: [
                { key: 'item_id', label: 'Item', sortable: false },
                {
                    key: 'complements_name',
                    label: 'Descrição do Item',
                    sortable: false
                },
                { key: 'initials', label: 'Und.', sortable: false },
                { key: 'quantity', label: 'Qtde.', sortable: false },
                { key: 'value_unit', label: 'Vr. Unitário', sortable: false },
                {
                    key: 'value_discount',
                    label: 'Vr. Desconto',
                    sortable: false
                },
                { key: 'value_total', label: 'Vr. Total', sortable: false },
                { key: 'comments', label: 'Observação', sortable: false },
                { key: 'actions', label: 'Ações' }
            ]
        }
    },
    computed: {
        issueDateState() {
            return this.release.issue_date ? true : false
        },
        releaseDateState() {
            return this.release.release_date ? true : false
        },
        releaseNumberState() {
            return this.release.release_number > 0 ? true : false
        },
        typeDocumentState() {
            return this.release.type_document_id ? true : false
        },
        costCenterState() {
            return this.release.cost_center_id ? true : false
        },
        releaseValueState() {
            return this.release.release_value > 0 ? true : false
        },
        typeCostState() {
            return this.release.type_cost_id ? true : false
        },
        operationState() {
            return this.release.operation_id ? true : false
        },
        operationLevelOneState() {
            return this.release.operation_level_one_id ? true : false
        },
        operationLevelTwoState() {
            return this.release.operation_level_two_id ? true : false
        },
        conditionPaymentReceiptState() {
            return this.release.condition_payment_receipt_id ? true : false
        },
        entityState() {
            return this.release.entity_id ? true : false
        },
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        splotSum() {
            let value = 0
            return this.releasesplots.map(splot => {
                return (value += parseFloat(splot.portion_value))
            })
        },
        apportionSum() {
            let value = 0
            return this.releasesapportionments.map(apport => {
                return (value += parseFloat(apport.apportionment_value))
            })
        },
        retentionSum() {
            let value = 0
            return this.releasesretentions.map(retention => {
                return (value += parseFloat(retention.retention_value))
            })
        },
        rowsItems() {
            return this.items.length
        },
        filteredListItems() {
            return this.items.filter(item => {
                return item.complements_name
                    .toLowerCase()
                    .includes(this.searchItem.toLowerCase())
            })
        }
    },
    methods: {
        setDateToday() {
            this.release = {
                ...this.release,
                issue_date: moment
                    .utc()
                    .local()
                    .format('YYYY-MM-DD')
            }
        },
        ItemValue() {
            return (this.releasesitem.value_total = parseFloat(
                parseFloat(
                    this.releasesitem.quantity ? this.releasesitem.quantity : 0
                ) *
                    (parseFloat(
                        this.releasesitem.value_unit
                            ? this.releasesitem.value_unit
                            : 0
                    ) -
                        (this.releasesitem.value_discount
                            ? this.releasesitem.value_discount
                            : 0))
            ).toFixed(2))
        },
        ItemUnitFinalValue() {
            return (this.releasesitem.final_value_unit = parseFloat(
                parseFloat(
                    this.releasesitem.value_unit
                        ? this.releasesitem.value_unit
                        : 0
                ) -
                    (this.releasesitem.value_discount
                        ? this.releasesitem.value_discount
                        : 0)
            ).toFixed(2))
        },
        finalValue() {
            return (this.releasesplot.final_value = parseFloat(
                this.releasesplot.portion_value -
                    (this.releasesplot.discount_value
                        ? this.releasesplot.discount_value
                        : 0) +
                    +(this.releasesplot.fine_value
                        ? this.releasesplot.fine_value
                        : 0) +
                    +(this.releasesplot.interest_rate_value
                        ? this.releasesplot.interest_rate_value
                        : 0)
            ).toFixed(2))
        },
        apportionmentValue() {
            if (this.releasesapportionment.apportionment_percent > 0) {
                return (this.releasesapportionment.apportionment_value = parseFloat(
                    this.release.release_value *
                        ((this.releasesapportionment.apportionment_percent
                            ? this.releasesapportionment.apportionment_percent
                            : 0) /
                            100)
                ).toFixed(2))
            }
        },
        apportionmentPercent() {
            return (this.releasesapportionment.apportionment_percent = parseFloat(
                this.release.release_value -
                    (this.releasesapportionment.apportionment_value
                        ? this.releasesapportionment.apportionment_value
                        : 0) /
                        100
            ).toFixed(2))
        },
        retentionValue() {
            return (this.releasesretention.retention_value = parseFloat(
                this.releasesretention.base_retention_value *
                    ((this.releasesretention.percent
                        ? this.releasesretention.percent
                        : 0) /
                        100)
            ).toFixed(2))
        },
        taxValue() {
            return (this.releasestax.tax_value = parseFloat(
                this.releasestax.base_tax_value *
                    ((this.releasestax.percent ? this.releasestax.percent : 0) /
                        100)
            ).toFixed(2))
        },
        goback() {
            this.$router.go(-1, { query: 'q=s', hash: 'hashFrag' })
        },
        formatDate(date) {
            return moment(date)
                .utcOffset(-3)
                .format('YYYY-MM-DD')
        },
        formatValue(value) {
            return parseFloat(value ? value : 0).toFixed(2)
        },
        formatDateTime(date) {
            return moment(date)
                .utcOffset(-3)
                .format('YYYY-MM-DD LT')
        },
        formatDateTimeReg(date) {
            return moment(date)
                .utcOffset(-3)
                .format('DD-MM-YYYY LT')
        },
        async validatedValueSplot() {
            await axios
                .get(`${baseApiUrl}/releasesplotsgettotal/${this.release.id}`)
                .then(() => {
                    this.release.checkvalueplot = 1
                })
                .catch(showError)
        },
        loadreleasesRetention(releasesretention) {
            if (releasesretention.base_date)
                releasesretention.base_date = this.formatDate(
                    releasesretention.base_date
                )
            if (releasesretention.due_date)
                releasesretention.due_date = this.formatDate(
                    releasesretention.due_date
                )
            this.loadRetention()
            this.releasesretention = { ...releasesretention }
        },
        loadreleasesApportionment(releasesapportionment) {
            this.releasesapportionment = { ...releasesapportionment }
            this.loadOperationsLevelOnes()
            this.loadOperationsLevelTwos()
        },
        loadreleasesTax(releasestax) {
            if (releasestax.base_date)
                releasestax.base_date = this.formatDate(releasestax.base_date)
            this.loadTax()
            this.releasestax = { ...releasestax }
        },
        setLastRelease(release) {
            this.oldrelease = { ...release }
        },
        loadReleasesPlot(releasesplot) {
            if (releasesplot.due_date)
                releasesplot.due_date = this.formatDate(releasesplot.due_date)
            if (releasesplot.scheduled_date)
                releasesplot.scheduled_date = this.formatDate(
                    releasesplot.scheduled_date
                )

            this.releasesplot = { ...releasesplot }
        },
        async loadreleases(id) {
            const url = `${baseApiUrl}/releases/${id}`
            await axios.get(url).then(res => {
                this.release = { ...res.data }
            })
        },
        async loadreleasesRetentions() {
            const id = this.release.id
            const url = `${baseApiUrl}/releasesretention/${id}/releases`
            await axios.get(url).then(res => {
                this.releasesretentions = res.data
            })
        },
        async loadreleasesApportionments() {
            const id = this.release.id
            const url = `${baseApiUrl}/releasesapportionment/${id}/releases`
            await axios.get(url).then(res => {
                this.releasesapportionments = res.data
            })
        },
        async loadreleasesTaxs() {
            const id = this.release.id
            const url = `${baseApiUrl}/releasestaxs/${id}/releases`
            await axios.get(url).then(res => {
                this.releasestaxs = res.data
            })
        },
        async loadreleasesPlots() {
            const id = this.release.id
            const url = `${baseApiUrl}/releasesplots/${id}/releases`
            await axios.get(url).then(res => {
                this.releasesplots = res.data
            })
        },
        async saveRelease() {
            if (this.release.id) {
                this.release.user_update_id = this.user.id
                this.release.update_date = this.formatDateTime(Date())
                this.release.checkvalueplot = 0
            } else {
                this.release.user_id = this.user.id
                if (!this.compan) {
                    this.$toasted.global.defaultError({
                        msg: 'Logar na Empresa'
                    })
                } else {
                    this.release.company_id = this.compan.id
                }
            }

            const method = this.release.id ? 'put' : 'post'
            const id = this.release.id ? `/${this.release.id}` : ''
            await axios[method](`${baseApiUrl}/releases${id}`, this.release)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.getLastRelease()

                    await Promise.all([
                        this.loadRetention(),
                        this.loadTax(),
                        this.loadreleasesPlots(),
                        this.loadreleasesApportionments(),
                        this.loadreleasesTaxs(),
                        this.loadreleasesRetentions()
                    ])
                })
                .catch(showError)
        },
        async getLastRelease() {
            const url = `${baseApiUrl}/releaseidlast/${this.release.company_id}/?user_id=${this.release.user_id}&operation_id=${this.release.operation_id}&entity_id=${this.release.entity_id}&type_document_id=${this.release.type_document_id}`
            await axios(url).then(res => (this.release.id = res.data.id))
        },
        async getAdvancedValue() {
            if (this.release.document_status_id === 1) {
                const url = `${baseApiUrl}/accountingentryadvanced/${this.compan.id}/?entity_id=${this.release.entity_id}&operation_id=${this.release.operation_id}`
                await axios(url).then(
                    res =>
                        (this.release = {
                            ...this.release,
                            advanced_value: res.data.value_advance
                        })
                )
            }
        },
        async confirmRelease() {
            this.splotsettlement = false

            this.releasesplots.map(splot => {
                if (splot.closed) {
                    this.splotsettlement = true
                }
            })

            if (this.splotsettlement) {
                this.$toasted.global.defaultWarning({
                    msg:
                        'Lançamento com Parcela Liquidado não pode ser alterado.'
                })
            } else {
                if (!this.compan.accounting_period_start) {
                    this.$toasted.global.defaultWarning({
                        msg: 'Empresa sem definição de Período Contábil'
                    })
                } else {
                    if (
                        this.formatDate(this.compan.accounting_period_start) >
                        this.formatDate(this.release.issue_date)
                    ) {
                        this.$toasted.global.defaultWarning({
                            msg: 'Data esta fora do período contábil'
                        })
                    } else if (
                        this.formatDate(this.compan.accounting_period_end) <
                        this.formatDate(this.release.issue_date)
                    ) {
                        this.$toasted.global.defaultWarning({
                            msg: 'Data esta fora do período contábil'
                        })
                    } else {
                        if (this.release.id) {
                            this.release.user_update_id = this.user.id
                            this.release.update_date = this.formatDateTime(
                                Date()
                            )

                            if (this.release.document_status_id === 1) {
                                this.release.document_status_id = 2
                            } else if (this.release.document_status_id === 2) {
                                this.release.document_status_id = 1
                            }

                            this.docRead =
                                this.release.document_status_id === 1
                                    ? false
                                    : true

                            const method = this.release.id ? 'put' : 'post'
                            const id = this.release.id
                                ? `/${this.release.id}`
                                : ''
                            await axios[method](
                                `${baseApiUrl}/releases${id}`,
                                this.release
                            )
                                .then(() => {
                                    this.$toasted.global.defaultSuccess()
                                })
                                .catch(showError)

                            this.releasesplots.map(async releasesplot => {
                                this.documentsettlement = {}
                                if (
                                    releasesplot.direct_settlement == 1 &&
                                    releasesplot.closed == 0
                                ) {
                                    this.documentsettlement.settlement_date = this.release.issue_date
                                    this.documentsettlement.company_id = this.release.company_id
                                    this.documentsettlement.release_plot_id =
                                        releasesplot.id
                                    this.documentsettlement.entity_settlement_id =
                                        releasesplot.entity_bank_cash_id
                                    this.documentsettlement.settlement_value =
                                        releasesplot.final_value
                                    this.documentsettlement.user_id = this.user.id

                                    await axios['post'](
                                        `${baseApiUrl}/documentsettlements`,
                                        this.documentsettlement
                                    ).catch(showError)
                                }
                            })

                            if (this.compan.require_account_entry === 1) {
                                await this.accountingRelease()
                            }

                            if (this.release.document_status_id === 2) {
                                this.goback()
                            }
                        }
                    }
                }
            }
        },
        async saveRetention() {
            if (this.releasesretention.id) {
                this.releasesretention.user_update_id = this.user.id
                this.releasesretention.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.releasesretention.user_id = this.user.id
            }
            const method = this.releasesretention.id ? 'put' : 'post'
            const id = this.releasesretention.id
                ? `/${this.releasesretention.id}`
                : ''
            this.releasesretention.release_id = this.release.id

            await axios[method](
                `${baseApiUrl}/releasesretentions${id}`,
                this.releasesretention
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    this.releasesretention = {}
                    this.release.checkvalueplot = 0
                    await this.loadreleasesRetentions()
                })
                .catch(showError)
        },
        async saveApportionment() {
            if (this.releasesapportionment.id) {
                this.releasesapportionment.user_update_id = this.user.id
                this.releasesapportionment.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.releasesapportionment.user_id = this.user.id
            }
            const method = this.releasesapportionment.id ? 'put' : 'post'
            const id = this.releasesapportionment.id
                ? `/${this.releasesapportionment.id}`
                : ''
            this.releasesapportionment.apportionment_operation_id = this.release.operation_id
            this.releasesapportionment.apportionment_release_id = this.release.id

            await axios[method](
                `${baseApiUrl}/releasesapportionments${id}`,
                this.releasesapportionment
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    this.releasesapportionment = {}
                    this.release.checkvalueplot = 0
                    await this.loadreleasesApportionments()
                })
                .catch(showError)
        },
        async saveTax() {
            if (this.releasestax.id) {
                this.releasestax.user_update_id = this.user.id
                this.releasestax.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.releasestax.user_id = this.user.id
            }

            const method = this.releasestax.id ? 'put' : 'post'
            const id = this.releasestax.id ? `/${this.releasestax.id}` : ''
            this.releasestax.release_id = this.release.id
            await axios[method](
                `${baseApiUrl}/releasestaxs${id}`,
                this.releasestax
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    this.releasestax = {}
                    await this.loadreleasesTaxs()
                })
                .catch(showError)
        },
        async savePlot() {
            if (this.releasesplot.id) {
                this.releasesplot.user_update_id = this.user.id
                this.releasesplot.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.releasesplot.user_id = this.user.id
            }
            const method = this.releasesplot.id ? 'put' : 'post'
            const id = this.releasesplot.id ? `/${this.releasesplot.id}` : ''
            this.releasesplot.release_id = this.release.id
            await axios[method](
                `${baseApiUrl}/releasesplots${id}`,
                this.releasesplot
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    this.releasesplot = {}
                    await this.loadreleasesPlots()
                    this.release.checkvalueplot = 0
                })
                .catch(showError)
        },
        async removeRetention(releasesretention) {
            const id = releasesretention.id
            await axios
                .delete(`${baseApiUrl}/releasesretentions/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadreleasesRetentions()
                })
                .catch(showError)
        },
        async removeTax(releasestax) {
            const id = releasestax.id
            await axios
                .delete(`${baseApiUrl}/releasestaxs/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadreleasesTaxs()
                })
                .catch(showError)
        },
        async removeApportionment(releasesapportionment) {
            const id = releasesapportionment.id
            await axios
                .delete(`${baseApiUrl}/releasesapportionments/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadreleasesApportionments()
                })
                .catch(showError)
        },
        async removePlot(releasesplot) {
            const id = releasesplot.id
            await axios
                .delete(`${baseApiUrl}/releasesplots/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadreleasesPlots()
                })
                .catch(showError)
        },
        async loadRetention() {
            if (this.release) {
                const url = `${baseApiUrl}/retentions/?operation_id=${this.release.operation_id}`
                await axios.get(url).then(res => {
                    this.retentions = res.data.map(retention => {
                        return {
                            value: retention.id,
                            text: retention.name_retention
                        }
                    })
                })
            }
        },
        async loadTax() {
            if (this.release) {
                const url = `${baseApiUrl}/taxs/?operation_id=${this.release.operation_id}`
                await axios.get(url).then(res => {
                    this.taxs = res.data.map(tax => {
                        return { value: tax.id, text: tax.name_tax }
                    })
                })
            }
        },
        async setEntity(entity) {
            if (!this.release.entity_id) {
                this.release.entity_id = entity.id
            }

            const url = `${baseApiUrl}/entitys/${this.release.entity_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        setSearchEntity() {
            this.release = { ...this.release, entity_id: this.entity_id }
        },
        loadTypeCost() {
            const url = `${baseApiUrl}/typecosts`
            axios.get(url).then(res => {
                this.typecosts = res.data.map(typecost => {
                    return { value: typecost.id, text: typecost.name_type_cost }
                })
            })
        },
        loadCostCenter() {
            const url = `${baseApiUrl}/costcentercompany/${this.compan.id}`
            axios.get(url).then(res => {
                this.costcenters = res.data.map(costcenter => {
                    return {
                        value: costcenter.id,
                        text: !costcenter.synthetic
                            ? ' => ' +
                              costcenter.internal_code_cost_center +
                              ' - ' +
                              costcenter.name_cost_center
                            : costcenter.internal_code_cost_center +
                              ' - ' +
                              costcenter.name_cost_center,
                        disabled: costcenter.synthetic ? true : false
                    }
                })
            })
        },
        loadConditionPaymentReceipt() {
            const url = `${baseApiUrl}/conditionpaymentreceipts`
            axios.get(url).then(res => {
                this.conditionpaymentreceipts = res.data.map(
                    conditionpaymentreceipt => {
                        return {
                            value: conditionpaymentreceipt.id,
                            text:
                                conditionpaymentreceipt.name_condition_payment_receipt
                        }
                    }
                )
            })
        },
        loadTypeDocument() {
            const url = `${baseApiUrl}/typedocuments`
            axios.get(url).then(res => {
                this.typedocuments = res.data.map(typedocument => {
                    return {
                        value: typedocument.id,
                        text: typedocument.name_reduced
                    }
                })
            })
        },
        loadDocumentStaus() {
            const url = `${baseApiUrl}/documentstatus`
            axios.get(url).then(res => {
                this.documentstatus = res.data.map(documentstatu => {
                    return {
                        value: documentstatu.id,
                        text: documentstatu.name_document_status
                    }
                })
            })
        },
        async loadOperation() {
            const url = `${baseApiUrl}/operations`
            await axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation
                    }
                })
            })
        },
        async loadOperationsLevelOnes() {
            const url = `${baseApiUrl}/operationslevelones/${this.release.operation_id}/operations`
            await axios.get(url).then(res => {
                this.operationslevelones = res.data.map(operationslevelone => {
                    return {
                        value: operationslevelone.id,
                        text: operationslevelone.name_operation_level_one
                    }
                })
            })
        },
        async loadOperationsLevelTwos() {
            const url = `${baseApiUrl}/operationsleveltwos/${this.releasesapportionment.apportionment_operation_level_one_id}/operationslevelones`
            await axios.get(url).then(res => {
                this.operationsleveltwos = res.data.map(operationsleveltwo => {
                    return {
                        value: operationsleveltwo.id,
                        text: operationsleveltwo.name_operation_level_two
                    }
                })
            })
        },
        loadSettlementForms() {
            const url = `${baseApiUrl}/settlementforms`
            axios.get(url).then(res => {
                this.settlementforms = res.data.map(settlementform => {
                    return {
                        value: settlementform.id,
                        text: settlementform.name_settlement_form
                    }
                })
            })
        },
        async loadSettlementOption() {
            const url = `${baseApiUrl}/settlementforms/${this.releasesplot.settlement_form_id}`
            await axios.get(url).then(res => {
                this.settlementform = res.data
            })
        },
        async unblocked() {
            const id = this.releasesplot.id
            await axios
                .put(`${baseApiUrl}/unblockedreleasespot/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadreleasesPlots()
                })
                .catch(showError)
        },
        async blocked() {
            const id = this.releasesplot.id
            await axios
                .put(`${baseApiUrl}/blockedreleasespot/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadreleasesPlots()
                })
                .catch(showError)
        },
        setDueDate() {
            this.releasesplot.scheduled_date = this.releasesplot.due_date
        },
        setNewSplot() {
            this.releasesplot = {}
        },
        setNewRetention() {
            this.releasesretention = {}
            this.loadRetention()
            this.releasesretention.base_retention_value = this.release.release_value
            this.releasesretention.base_date = moment(this.release.issue_date)
                .utcOffset(-3)
                .format('YYYY-MM-DD')
        },
        setNewTax() {
            this.releasestax = {}
            this.loadTax()
            this.releasestax.base_tax_value = this.release.release_value
            this.releasestax.base_date = moment(this.release.issue_date)
                .utcOffset(-3)
                .format('YYYY-MM-DD')
        },
        setNewApportionment() {
            this.releasesapportionment = {}
            this.loadOperationsLevelOnes()
        },
        loadEntitySettlements() {
            const url = `${baseApiUrl}/entitysettement/${this.compan.id}`
            axios.get(url).then(res => {
                this.entitysettlements = res.data.map(entitysettlement => {
                    return {
                        value: entitysettlement.id,
                        text: `${entitysettlement.name_entity} - ${entitysettlement.cnpj_cpf}`
                    }
                })
            })
        },
        async insertReleaseSplotConfditionPayment() {
            if (this.release.id) {
                if (
                    this.releasesplot.account_credit_card_id > 0 &&
                    this.release.operation_id == 2
                ) {
                    if (
                        !this.releasesplot.account_credit_card_rate_id ||
                        !this.releasesplot.account_credit_card_rate_condition_id
                    ) {
                        this.$toasted.global.defaultWarning({
                            msg:
                                'Para Cartão de Crédito/Débito é necessário informa a modalidade/prazo.'
                        })
                    } else {
                        const url = `${baseApiUrl}/insertreleasesplotcardcredit/${this.release.id}
                                        /?condition_payment_receipt_id=${this.release.condition_payment_receipt_id}
                                        &release_value=${this.release.release_value}
                                        &issue_date=${this.release.issue_date}
                                        &settlement_form_id=${this.releasesplot.settlement_form_id}
                                        &user_id=${this.user.id}
                                        &entity_bank_cash_id=${this.releasesplot.entity_bank_cash_id}
                                        &account_credit_card_id=${this.releasesplot.account_credit_card_id}
                                        &account_credit_card_rate_id=${this.releasesplot.account_credit_card_rate_id}
                                        &account_credit_card_rate_condition_id=${this.releasesplot.account_credit_card_rate_condition_id}
                                        `
                        await axios
                            .post(url)
                            .then(async () => {
                                this.$toasted.global.defaultSuccess()
                                await this.loadreleasesPlots()
                                await this.loadreleasesRetentions()
                                this.release.checkvalueplot = 0
                            })
                            .catch(showError)
                    }
                } else {
                    const url = `${baseApiUrl}/insertreleasesplotconditionpaymentReceipt/${
                        this.release.id
                    }/?condition_payment_receipt_id=${
                        this.release.condition_payment_receipt_id
                    }&release_value=${
                        this.retentionSum > 0
                            ? this.release.release_value -
                              this.formatValue(this.retentionSum)
                            : this.release.release_value
                    }&issue_date=${
                        this.release.issue_date
                    }&settlement_form_id=${
                        this.releasesplot.settlement_form_id
                    }&user_id=${this.user.id}`

                    await axios
                        .post(url)
                        .then(async () => {
                            this.$toasted.global.defaultSuccess()
                            await this.loadreleasesPlots()
                            this.release.checkvalueplot = 0
                        })
                        .catch(showError)
                }
            }
        },
        hideModal() {
            this.$bvModal.hide('modalEntity')
            this.$bvModal.hide('modalLastRelease')
        },
        async accountingRelease() {
            if (this.release.document_status_id === 2) {
                await axios['post'](
                    `${baseApiUrl}/accountingrelease`,
                    this.release
                )
                    .then(async () => {
                        if (this.releasesretentions) {
                            await this.accountingReleaseRetention()
                        } else {
                            this.$toasted.global.defaultSuccess()
                        }
                    })
                    .catch(showError)
            }
        },
        async accountingReleaseRetention() {
            if (this.release.document_status_id === 2) {
                await axios['post'](
                    `${baseApiUrl}/accountingreleaseretention`,
                    this.release
                )
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                    })
                    .catch(showError)
            }
        },
        async loadLastReleases() {
            if (this.release.entity_id > 0) {
                const url = `${baseApiUrl}/lastreleasescompanyentitys/${this.compan.id}/?entity_id=${this.release.entity_id}`
                await axios.get(url).then(res => {
                    this.last_releases_entitys = res.data
                })

                //this.$refs['modalLastRelease'].show()
                this.$bvModal.show('modalLastRelease')
            }
        },
        actionEditRelease(release) {
            if (release.issue_date)
                release.issue_date = this.formatDate(release.issue_date)
            if (release.release_date)
                release.release_date = this.formatDate(release.release_date)

            this.$router.push({
                name: 'Recordrelease',
                query: { releasebase: release }
                //params: {id: release.id}
            })
        },
        openModalEntity() {
            this.$bvModal.show('modalEntity')
        },
        openModalItem() {
            this.$bvModal.show('modalItem')
        },
        focusAdd() {
            this.$refs.focusadd.focus()
        },
        focusModalItem() {
            this.$refs.focusItem.focus()
        },
        focusModalEntryItem() {
            this.$refs.focusEntryItem.focus()
        },
        focusModalEntryItemQuantity() {
            this.$refs.focusEntryItemQuantity.focus()
        },
        async saveNewRelease() {
            if (!this.compan) {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            }
            this.formatDate()
            this.newrelease = {
                ...this.newrelease,
                release_date: moment()
                    .utc()
                    .local()
                    .format('YYYY-MM-DD'),
                user_id: this.user.id,
                company_id: this.compan.id,
                id: this.oldrelease.id,
                entity_id: this.oldrelease.entity_id,
                type_document_id: this.oldrelease.type_document_id,
                condition_payment_receipt_id: this.oldrelease
                    .condition_payment_receipt_id,
                operation_id: this.oldrelease.operation_id,

                comments: this.oldrelease.comments
            }

            const method = 'post'
            await axios[method](`${baseApiUrl}/newreleases`, this.newrelease)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                })
                .catch(showError)
        },
        setItemSearch(itemsearch) {
            this.item = { ...itemsearch }
            this.releasesitem.item_id = this.item.id
            this.focusModalEntryItemQuantity()
        },
        async setItem() {
            const url = `${baseApiUrl}/items/${this.releasesitem.item_id}`
            await axios(url).then(res => (this.item = res.data))
        },
        async loadReleaseItems() {
            const id = this.release.id
            const url = `${baseApiUrl}/releasesitems/${id}/releases`
            await axios.get(url).then(res => {
                this.releasesitems = res.data
            })
        },
        loadItems() {
            const url = `${baseApiUrl}/groupitems/${this.group_item_id}/items`
            axios.get(url).then(res => {
                this.items = res.data
            })
        },
        loadReleaseItem(item) {
            this.releasesitem = { ...item }
            this.item.complements_name = item.complements_name
            this.item.initials = item.initials
        },
        loadGroupItems() {
            const url = `${baseApiUrl}/groupitems`
            axios.get(url).then(res => {
                this.groupitems = res.data.map(groupitem => {
                    return {
                        value: groupitem.id,
                        text: !groupitem.synthetic
                            ? ' => ' + groupitem.name
                            : groupitem.name,
                        disabled: groupitem.synthetic ? true : false
                    }
                })
            })
        },
        async saveReleaseItem() {
            const method = this.releasesitem.id ? 'put' : 'post'
            const id = this.releasesitem.id ? `/${this.releasesitem.id}` : ''

            this.releasesitem.user_id = this.user.id
            this.releasesitem.release_id = this.release.id

            await axios[method](
                `${baseApiUrl}/releasesitems${id}`,
                this.releasesitem
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    this.releasesitem = {}
                    await this.loadReleaseItems()
                })
                .catch(showError)
        },
        async loadSeries() {
            const url = `${baseApiUrl}/series/${this.release.type_document_id}/typedocuments`
            await axios.get(url).then(res => {
                this.series = res.data.map(serie => {
                    return { value: serie.id, text: serie.serie }
                })
            })
        },

        async automaticRelease() {
            await axios
                .post(`${baseApiUrl}/automaticrelease`, this.release)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadreleasesApportionments()
                    this.loadreleasesPlots()
                })
                .catch(showError)
        },
        loadAccountCreditCards() {
            const url = `${baseApiUrl}/accountcreditcardcompanys/${this.release.company_id}`
            axios.get(url).then(res => {
                this.accountcreditcards = res.data.map(accountcreditcard => {
                    return {
                        value: accountcreditcard.id,
                        text: accountcreditcard.name_account_credit_card
                    }
                })
            })
        },
        loadAccountCreditCardsRates() {
            const url = `${baseApiUrl}/accountcreditcardsratescreditcard/${this.releasesplot.account_credit_card_id}`
            axios.get(url).then(res => {
                this.accountcreditcardsrates = res.data.map(
                    accountcreditcard => {
                        return {
                            value: accountcreditcard.id,
                            text: accountcreditcard.rate_name
                        }
                    }
                )
            })
        },
        loadAccountCreditCardsRateConditions() {
            const url = `${baseApiUrl}/accountcreditcardsratesconditionreceipts/${this.releasesplot.account_credit_card_rate_id}`
            axios.get(url).then(res => {
                this.accountcreditcardsratesconditionreceipts = res.data.map(
                    accountcreditcard => {
                        return {
                            value: accountcreditcard.id,
                            text: accountcreditcard.number_portion
                        }
                    }
                )
            })
        },
        addSpot() {
            this.releasesplot = {}
            this.settlementform = {}
        }
    },
    watch: {
        $route(to) {
            this.release = to.query.releasebase
            //this.release.id = to.params.id
            //this.loadReleasebase()
        }
    },
    async mounted() {
        if (
            this.$route.query.releasebase &&
            this.$route.query.releasebase.release_id
        ) {
            await this.loadreleases(this.$route.query.releasebase.release_id)

            this.docRead = true
            this.entity.name_entity = this.$route.query.releasebase.name_entity
            this.entity.cnpj_cpf = this.$route.query.releasebase.cnpj_cpf
            this.release.issue_date = this.formatDate(this.release.issue_date)
            this.release.release_date = this.formatDate(
                this.release.release_date
            )
        } else {
            this.release = this.$route.query.releasebase
            this.docRead = this.release.document_status_id === 1 ? false : true
            this.entity.name_entity = this.release.name_entity
            this.entity.cnpj_cpf = this.release.cnpj_cpf
        }

        if (!this.release.release_date) {
            this.release.release_date = moment
                .utc()
                .local()
                .format('YYYY-MM-DD')
            //this.release.issue_date = moment.utc(date).local().format('YYYY-MM-DD')
        }

        //this.loadRelease()
        this.loadreleasesRetentions()
        this.loadreleasesApportionments()
        this.loadreleasesTaxs()
        this.loadTypeCost()
        this.loadCostCenter()
        this.loadConditionPaymentReceipt()
        this.loadTypeDocument()
        this.loadOperation()
        this.loadreleasesPlots()
        this.loadDocumentStaus()
        this.loadSettlementForms()
        this.loadEntitySettlements()
        this.loadGroupItems()
        this.$refs.inputFist.focus()
    }
}
</script>

<style>
.record-release select,
label {
    font-size: 0.7rem;
}
.record-release input {
    font-size: 0.7rem;
}
.record-release button {
    font-size: 0.7rem;
}

.record-release textarea {
    font-size: 0.7rem;
}

#modalEntity {
    font-size: 0.7rem;
}

#modalEntity select,
label {
    font-size: 0.7rem;
}

#modalEntity input {
    font-size: 0.7rem;
}

#modalEntity button {
    font-size: 0.7rem;
}

#modalSplotConditionPayment select,
label {
    font-size: 0.7rem;
}

#modalSplotConditionPayment button {
    font-size: 0.7rem;
}

#modalPlots {
    font-size: 0.7rem;
}

#modalPlots select,
label {
    font-size: 0.7rem;
}

#modalPlots input {
    font-size: 0.7rem;
}

#modalPlots button {
    font-size: 0.7rem;
}

#modalTax {
    font-size: 0.7rem;
}

#modalTax select,
label {
    font-size: 0.7rem;
}

#modalTax input {
    font-size: 0.7rem;
}

#modalTax button {
    font-size: 0.7rem;
}

#modalRetention {
    font-size: 0.7rem;
}

#modalRetention select,
label {
    font-size: 0.7rem;
}

#modalRetention input {
    font-size: 0.7rem;
}

#modalRetention button {
    font-size: 0.7rem;
}

#modalApportionment {
    font-size: 0.7rem;
}

#modalApportionment select,
label {
    font-size: 0.7rem;
}

#modalApportionment input {
    font-size: 0.7rem;
}

#modalApportionment button {
    font-size: 0.7rem;
}

#modalLastRelease {
    font-size: 0.7rem;
}

#modalLastRelease table {
    font-size: 0.7rem;
}

#modalLastRelease button {
    font-size: 0.7rem;
}

#modalNewRelease {
    font-size: 0.7rem;
}

#modalNewRelease select,
label {
    font-size: 0.7rem;
}

#modalNewRelease input {
    font-size: 0.7rem;
}

#modalNewRelease button {
    font-size: 0.7rem;
}

#modalReleaseItem select,
label {
    font-size: 0.7rem;
}

#modalReleaseItem input {
    font-size: 0.7rem;
}

#modalReleaseItem button {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
